import { all, call, select, takeLatest } from 'redux-saga/effects';

import { fidoV2 as fido } from '@bsd/ui-utils';

import { types } from 'modules/common/index';

import { getTrackingId, getLogContext } from 'modules/application/selectors';

import { LOG_LEVELS, REDIRECT_TYPES } from 'modules/common/constants';
import { API_ROUTES, API_KEYS } from 'endpoints';

function* logErrorWorker({ payload }) {
  const { applicationId } = yield select(getLogContext);
  const trackingId = yield select(getTrackingId);
  const endpoint = API_ROUTES[API_KEYS.logging].endpoints.log;

  const options = {
    data: {
      applicationId,
      trackingId,
      message: payload.message,
      level: LOG_LEVELS.error,
    },
  };

  try {
    yield call(fido.fetch, endpoint, options);
    return true;
  } catch {
    return false;
  }
}

function* redirectToUrlWorker({ payload }) {
  const { history, type, url } = payload;
  const newBaseUrl = `${window.location.origin}${url}`;

  switch (type) {
    case REDIRECT_TYPES.replace:
      window.location.assign(newBaseUrl);
      break;
    case REDIRECT_TYPES.absolute:
      window.location.assign(url);
      break;
    case REDIRECT_TYPES.relative:
      yield call(history.push, url);
      break;
    default:
      yield call(history.push, url);
  }
}

export const workers = {
  logErrorWorker,
  redirectToUrlWorker,
};

// Watchers
function* commonWatch() {
  yield all([
    takeLatest(types.ERROR_LOG, logErrorWorker),
    takeLatest(types.URL_REDIRECT, redirectToUrlWorker),
  ]);
}

export const watchers = {
  commonWatch,
};

// Sagas
export default function* rootSaga() {
  yield commonWatch();
}
